var classes = {"utilityLinks":"JYuAi","divider":"gk5hS"};

export { classes as default };
